import { RPDF, Text, View } from '../common/react-pdf';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';

export const VisitColumns: React.FC = () => {
  const i18next = useScopedTranslation('calendar.report.table_columns');
  return (
    <RPDF.View style={RPDF.styles.columnsContainer}>
      <RPDF.View style={RPDF.tableColumnsStyles.timeColumn}>
        <RPDF.Text style={RPDF.styles.columnText}>
          {i18next.t('date_time')}
        </RPDF.Text>
      </RPDF.View>
      <RPDF.View style={RPDF.tableColumnsStyles.visitTypeColumn}>
        <RPDF.Text style={RPDF.styles.columnText}>
          {i18next.t('visit_type')}
        </RPDF.Text>
      </RPDF.View>
      <RPDF.View style={RPDF.tableColumnsStyles.patientColumn}>
        <RPDF.Text style={RPDF.styles.columnText}>
          {i18next.t('patient')}
        </RPDF.Text>
      </RPDF.View>
      <RPDF.View style={RPDF.tableColumnsStyles.doctorColumn}>
        <RPDF.Text style={RPDF.styles.columnText}>
          {i18next.t('doctor')}
        </RPDF.Text>
      </RPDF.View>
    </RPDF.View>
  );
};
